export default {
  locale: "en",
  name: "Contracts",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [],
  },
};
